import { Injectable, Inject } from '@angular/core';
import { AngularFireDatabase } from "angularfire2/database";
import { Observable, Subject } from "rxjs/Rx";
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/combineLatest';
import { FirebaseListFactoryOpts } from "angularfire2/database/interfaces";
import { Institution } from '../model/institution';
// import { Client } from '../model/client'
import { FirebaseApp } from 'angularfire2';

@Injectable()
export class InstitutionsService {
  sdkdb: any;

  constructor(private db: AngularFireDatabase, @Inject(FirebaseApp) fb: FirebaseApp) {
    this.sdkdb = fb.database().ref();
  }

  findAllInstitutions(): Observable<Institution[]> {
    return this.db.list('institutions').map(Institution.fromJsonArray);
  }

  findInstitutionByInstitutionName(institutionName: string): Observable<Institution> {
    return this.db.list('institutions', {
      query: {
        orderByChild: 'institutionName',
        equalTo: institutionName
      }
    })
      .map(results => results[0]);
  }

  // Find an Institution by Institution ID.  Return Only one Institution.  It's why I convert
  // the observable to a promise
  findInstitutionById(id: string): Observable<Institution> {
    return this.db.object(`institutions/${id}`)
      .map(results => Institution.fromJson(results))
      .take(1)
  }


  // findClientKeysPerInstitutionName(institutionName: string,
  //   query: FirebaseListFactoryOpts = {}): Observable<string[]> {
  //   return this.findInstitutionByInstitutionName(institutionName)
  //     .switchMap(institution => this.db.list(`clientsPerInstitution/${institution.$key}`, query))
  //     .map(lspc => lspc.map(lpc => lpc.$key));
  // }

  // // Take an observable of list of clients id's and transform in an observable of clients
  // findClientsForClientKeys(clientKeys$: Observable<string[]>): Observable<Client[]> {
  //   return clientKeys$
  //     .map(lspc => lspc.map(clientKey => this.db.object('clients/' + clientKey)))
  //     .mergeMap(fbojs => Observable.combineLatest(fbojs));
  // }

  // findAllClientsForInstitution(institutionName: string): Observable<Client[]> {
  //   return this.findClientsForClientKeys(this.findClientKeysPerInstitutionName(institutionName));
  // }

  firebaseUpdate(dataToSave) {
    const subject = new Subject();
    this.sdkdb.update(dataToSave)
      .then(
      val => {
        subject.next(val);
        subject.complete();
      },
      err => {
        subject.error(err);
        subject.complete();
      }
      );

    return subject.asObservable();
  }

  saveInstitution(institutionId, institution): Observable<any> {
    // const institutionId = this.sdkdb.push().key;
    if (!institutionId) {
      institutionId = this.getNewInstitutionKey();
    }
    institution.$key = institutionId
    const institutionToSave = Object.assign({}, institution);
    delete (institutionToSave.$key);

    let dataToSave = {};
    dataToSave[`institutions/${institutionId}`] = institutionToSave;

    return this.firebaseUpdate(dataToSave);

  }

  getNewInstitutionKey(): string {
    return this.sdkdb.push().key;
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/services/institutions.service.ts